export class RestoreInstanceVolumeInput {
    'providerVolumeId';
    'description';
    'tags';
    'volumeEncryptionKeyId';
    'volumeSettings';
    'encryptionKeyId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerVolumeId",
            "baseName": "providerVolumeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "volumeEncryptionKeyId",
            "baseName": "volumeEncryptionKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "volumeSettings",
            "baseName": "volumeSettings",
            "type": "VolumeSettings",
            "format": ""
        },
        {
            "name": "encryptionKeyId",
            "baseName": "encryptionKeyId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreInstanceVolumeInput.attributeTypeMap;
    }
    constructor() {
    }
}
